import { ChatToolProvider } from '#core/components/chat/contexts/ChatToolProvider';

import { FieldView, ReservoirView } from '#views';

// import { useCreateDashboardTool } from '#hooks/tools/useCreateDashboardTool';
import { useHydroblendFunctionTool } from '#hooks/tools/useHydroblendFunctionTool';
import { useQueryDataModelTool } from '#hooks/tools/useQueryDataModelTool';
import { useFastSiFunctionTool } from '#hooks/tools/useFastSiFunctionTool';
import { useResChemFunctionTool } from '#hooks/tools/useResChemFunctionTool';
// import { TimeSeriesBarChart } from '#core/components/dashboard/components/TimeSeriesBarChart';
// import { TimeSeriesLineChart } from '#core/components/dashboard/components/TimeSeriesLineChart';

export function AppProvider({ children }: React.PropsWithChildren) {
  return (
    <ChatToolProvider
      tools={[
        useQueryDataModelTool(FieldView, ReservoirView),
        useHydroblendFunctionTool(),
        useFastSiFunctionTool(),
        useResChemFunctionTool(),
        // useCreateDashboardTool(TimeSeriesLineChart, TimeSeriesBarChart),
      ]}
    >
      {children}
    </ChatToolProvider>
  );
}
